"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Input_1 = require("./Input");
/**
 * OUI text input component.
 *
 * @oui-component TextInput
 */
var TextInput = function (props) { return React.createElement(Input_1.default, __assign({}, props, { type: Input_1.InputTypes.Text })); };
exports.default = TextInput;
//# sourceMappingURL=TextInput.js.map